// extracted by mini-css-extract-plugin
module.exports = {"modal":"salesHistory_modal__2cl5-","salesHistory":"salesHistory_salesHistory__2CH2C","header":"salesHistory_header__SUE6w"};